<template>
  <div>
    <div class="w-full xl:w-11/12 mx-auto px-3 pb-12">
      <div class="w-full md:w-3/4 max-w-5xl mx-auto mt-3 md:mt-4 bg-gray-300 sm:rounded-lg p-5 ">
        <div class="flex justify-between items-center pb-1 mb-1 ">
          <p class="text-3xl font-light pb-2 text-center">Search Past Shows</p>
        </div>
        <div class="flex flex-wrap justify-between items center">
          <div id="find-show" class="w-full md:w-1/3 px-1 mt-1 md:mt-0">
            <label for="location" class="block text-sm font-medium text-gray-700">Search by name</label>
            <input @change="setSearchParams('name', showFilterValue)" class="bg-white border border-gray-300 text-gray-700 rounded-lg py-3 px-4 w-full mt-1" v-model="showFilterValue" placeholder="Show Search"/>
          </div>
          <div id="show-year" class="w-full md:w-1/6 px-1 mt-1 md:mt-0">
            <label for="location" class="block text-sm font-medium text-gray-700">Year</label>
            <div class="relative mt-1 ">
              <select v-model="year" @change="setSearchParams('year', year);getPastShowsByYear();" class="block appearance-none w-full bg-white border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                <option v-for="y in listOfYears"  :key="y" :value="y">
                  {{y}}
                </option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/3 px-1 mt-1 md:mt-0">
            <label for="location" class="block text-sm font-medium text-gray-700">Filter by species</label>
            <div class="relative mt-1 ">
              <select v-model="speciesFilter" @change="setSearchParams('species', speciesFilter)" class="block appearance-none w-full bg-white border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                <option :value="null" selected>
                  All Species
                </option>
                <option v-for="s in speciesList"  :key="s.value" :value="s.value">
                  {{s.label}}
                </option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/6 px-1 mt-1 md:mt-0">
            <label for="location" class="block text-sm font-medium text-gray-700">Filter by state</label>
            <div class="relative mt-1 ">
              <select v-model="stateFilter" @change="setSearchParams('state', stateFilter)" class="block appearance-none w-full bg-white border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                <option :value="null" selected>
                  All States
                </option>
                <option v-for="s in Localized.allStateList"  :key="s.name" :value="s.abbreviation">
                  {{s.name}}
                </option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showSearch.length || showFilterValue" class="bg-gray-300 w-full md:w-3/4 max-w-5xl mx-auto -mt-3 p-2 rounded-lg">
        <h2 class="text-3xl font-semibold mb-4 text-center">Search Results</h2>
        <div class="flex flex-wrap justify-center ">
          <event-card type="small" v-for="(s,k) in showSearch" :key="k" :event="s" class="m-3 border w-full sm:w-56"></event-card>
        </div>
        <p v-if="!showSearch.length">No Shows Found</p>
      </div>
      <div v-if="showList.length > 0" class="mt-8">
        <div class="relative mb-8">
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-gray-300"></div>
          </div>
          <div class="relative flex justify-center">
            <h2 class="px-3 bg-white md:bg-gray-100 text-3xl font-medium text-gray-900">
              {{ year }} Shows
            </h2>
          </div>
        </div>
        <div class="flex flex-wrap justify-center ">
          <event-card v-for="(s,k) in showList" :key="k" :event="s" class="m-3 border w-full"></event-card>
        </div>
      </div>
      <div v-else-if="loading">
        <vue-simple-spinner class="mt-12" size="huge" :speed="1.1" :line-size="7" message="Loading Data..." line-fg-color="orange"/>
      </div>
    </div>
  </div>
</template>

<script>
import EventCard from '@/components/EventCard.vue'

export default {
  components: {
    EventCard
  },
  data () {
    return {
      pastShowsByYear: [],
      year: null,
      showFilterValue: '',
      stateFilter: null,
      speciesFilter: null,
      speciesList: [
        {
          value: 'CATTLE',
          label: 'Beef Cattle'
        },
        {
          value: 'DAIRY CATTLE',
          label: 'Dairy Cattle'
        },
        {
          value: 'SWINE',
          label: 'Swine'
        },
        {
          value: 'SHEEP',
          label: 'Sheep'
        },
        {
          value: 'GOATS',
          label: 'Meat Goats'
        },
        {
          value: 'DAIRY GOATS',
          label: 'Dairy Goats'
        },
        {
          value: 'OTHER',
          label: 'Other'
        }
      ],
      loading: false
    }
  },
  methods: {
    getPastShowsByYear () {
      this.pastShowsByYear = []
      this.loading = true
      this.$store.state.apiInstance.get(`/callFunction/getEventsByYear?year=${this.year}`)
        .then(response => {
          this.pastShowsByYear = response.data.data
          this.loading = false
        })
    },
    setSearchParams (field, value) {
      this.$store.dispatch('setArchiveSearchParam', {field: field, value: value})
    }
  },
  computed: {
    showList () {
      let list = this.pastShowsByYear
      if (this.btrjla_shows) {
        list = list.filter(s => s.event_settings.btrjla_sanctioned)
      }
      if (this.stateFilter) {
        list = list.filter(s => s.location_details.state === this.stateFilter)
      }
      if (this.speciesFilter) {
        list = list.filter(s => {
          if (s.species) {
            return s.species.some(sp => sp.species === this.speciesFilter)
          } else {
            return false
          }
        })
      }
      return list
    },
    listOfYears () {
      const currentYear = new Date().getFullYear()
      const startYear = 2019
      const years = []

      for (let year = currentYear; year >= startYear; year--) {
        years.push(year)
      }

      return years
    },
    showSearch () {
      if (this.showFilterValue === '') {
        return []
      }
      let allEvents = this.pastShowsByYear
      return allEvents.filter(e => {
        let value = this.showFilterValue.trim().replace(/\\+/g, '')
        const regex = new RegExp(value, 'gi')
        if (e.name.match(regex)) {
          return e
        }
      })
    }
  },
  created () {
    let speciesParameter = this.$store.state.archiveSearchParams.species
    if (speciesParameter) {
      this.speciesFilter = speciesParameter.toUpperCase()
    } else {
      let urlSpeciesParam = this.getParameterByName('species')
      if (urlSpeciesParam) {
        this.speciesFilter = urlSpeciesParam.toUpperCase()
      }
    }
    let stateParameter = this.$store.state.archiveSearchParams.state
    if (stateParameter) {
      this.stateFilter = stateParameter.toUpperCase()
    }
    let showSearchParam = this.$store.state.archiveSearchParams.name
    if (showSearchParam) {
      this.showFilterValue = showSearchParam
    }
    let yearParameter = this.$store.state.archiveSearchParams.year
    if (yearParameter) {
      this.year = this.$store.state.archiveSearchParams.year
    } else {
      this.year = new Date().getFullYear()
    }
    this.getPastShowsByYear()
  }
}
</script>

<style>

</style>
